import React, { useState } from 'react';
import ButtonToggle from '../../atoms/buttonToggle/view';
import { Col, Row } from 'react-bootstrap';
import './style.css';

const FormToggle = ({ label, onChange, initialValue = false }) => {
  const [isOn, setIsOn] = useState(initialValue);

  const handleToggle = () => {
    const newValue = !isOn;
    setIsOn(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <div className="form-toggle-container">
      <Row className="align-items-center">
        <Col xs={8}>
          <span className="form-toggle-label">{label}</span>
        </Col>
        <Col xs={4} className="text-end">
          <ButtonToggle onClick={handleToggle} style={{ minWidth: '80px' }}>
            {isOn ? 'SÍ' : 'NO'}
          </ButtonToggle>
        </Col>
      </Row>
    </div>
  );
};

export default FormToggle;
